import Vue from 'vue'
import router from './router/index.js'
import { appRouter } from './router/router'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import en from 'iview/dist/locale/en-US'
import cn from 'iview/dist/locale/zh-CN'
import VueI18n from 'vue-i18n'
import store from './store'
import Locales from './locale'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
import element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import elementEn from 'element-ui/lib/locale/lang/en'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'
import axios from 'axios'
import './assets/PublicStyle.css'
import './assets/common/style.css'
import behaviors from './assets/behaviors.js'
import publicJS from './assets/publicJS.js'
import ConstDefinition from './utils/constDefinition'
import tips from './views/components/tips'
import App from './App'
import Viewer from 'v-viewer' // 图片预览
import 'viewerjs/dist/viewer.css'
import {setCookie,getCookie,delCookie} from '@/assets/cookie'
Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}

var attachmentAxios = axios.create({
    baseURL: process.env.COREAPI_HOST,
    timeout: 1000 * 60 * 30
});
Vue.prototype.$attachemtnHttp = attachmentAxios

Vue.prototype.$http = axios
Vue.prototype.$constDefinition = ConstDefinition
Vue.prototype.$SiteBaseUrl = process.env.COREAPI_HOST
Vue.prototype.behaviors = behaviors
Vue.prototype.publicJS = publicJS
Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.locale = () => {}
const messages = {
    mergeEN: Object.assign(Locales['en-US'], en, elementEn),
    mergeZH: Object.assign(Locales['zh-CN'], cn, elementZh)
}

const i18nData = new VueI18n({
    locale: localStorage.getItem('currentLanguage') === null ? 'mergeZH' : localStorage.getItem('currentLanguage'),
    messages,
    fallbackLocale : 'mergeZH'
})

Vue.use(iView, { i18n: (key, value) => i18nData.t(key, value) })
Vue.use(element, {
    i18n: (key, value) => i18nData.t(key, value)
})

Vue.filter('decimalformat', function(input, scale) {
    return Number(input).toFixed(scale)
})

Vue.filter('dateformat', function(input, formatstring) {
    return dayjs(input).format(formatstring)
})
Vue.use(tips)
Vue.component('tips', tips)

Vue.use(Viewer)
Viewer.setDefaults({
    Options: {
        'zIndex': 9999,
        'inline': true,
        'button': true,
        'navbar': true,
        'title': true,
        'toolbar': true,
        'tooltip': true,
        'movable': true,
        'zoomable': true,
        'rotatable': true,
        'scalable': true,
        'transition': true,
        'fullscreen': true,
        'keyboard': true,
        'url': 'data-source'
    }
})

// eslint-disable-next-line no-extend-native
Number.prototype.toFixed = function(s) {
    let num = this;
    let absNum = Math.abs(num);
    let changenum = (parseInt(absNum * Math.pow(10, s) + 0.5) / Math.pow(10, s)).toString();
    let index = changenum.indexOf('.');
    if (index < 0 && s > 0) {
        changenum = changenum + '.';
        for (let i = 0; i < s; i++) {
            changenum = changenum + '0';
        }
    } else {
        index = changenum.length - index;
        for (let i = 0; i < (s - index) + 1; i++) {
            changenum = changenum + '0';
        }
    }
    if (num < 0) { changenum = `-${changenum}`; }
    return changenum;
}

let vm = new Vue({
    el: '#app',
    i18n: i18nData,
    router: router,
    components: {
        App,
        tips
    },
    template: '<App/>',
    store,
    appRouter: appRouter
})
Vue.use({
    vm
})


// WEBPACK FOOTER //
// ./src/main.js